<template>
  <div
    :style="`background:${value.background};color:${value.colour};padding:20px;margin-bottom:5px;border-radius:20px;`"
  >
    <h1>{{ value.heading }}</h1>
    <p>{{ value.subheading }}</p>
    <div
      style="
        background: white;
        padding: 5px 25px;
        display: inline-block;
        border-radius: 100px;
        box-shadow: 5px 5px grey;
      "
    >
      <a style="text-decoration: none"
        >{{ buttons.find((i) => value.button == i.id).name }} &gt;</a
      >
    </div>
  </div>
</template>

<script>
import { buttonList } from "@/util/helpers";
export default {
  name: "EmailPanel",
  props: ["value"],
  data() {
    return { buttons: null };
  },
  created() {
    this.buttons = buttonList();
  }
};
</script>